module.exports = __webpack_public_path__ + "media/bg.166cffa6.mp4";